// extracted by mini-css-extract-plugin
module.exports = {"fix-padding-bottom":"styles_fix-padding-bottom__12HPm"};